import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotTopicsSection from './components/HotTopicsSection';
import LatestArticlesSection from './components/LatestArticlesSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import CategoryNavSection from './components/CategoryNavSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <HotTopicsSection />
        <LatestArticlesSection />
        <CTASection />
        <CategoryNavSection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}